import { calculateDependentFormValue } from './calculateDependentFormValue';

export default calculateDependentFormValue;
